angular.module('omfm').service('Commands', CommandsService);

CommandsService.$inject = ['$resource', 'ServerInterceptor'];

function CommandsService($resource, ServerInterceptor) {
	return $resource('/commands', {"id": "@id"}, {
		'list': {
			'url': "/commands/list",
			'interceptor': ServerInterceptor
		},
		'run': {
			'url': "/commands/run",
			'interceptor': ServerInterceptor
		}
	})
}